export const SubledgerEndpoints = {
  currencyCodesGetPath: "/CurrencyCodes",
  slEntryPath: "/slEntry/Entry/",
  slReviewers: "/slEntry/reviewers/",
  slAttachment: "/slEntry/attachment/",
  slDashboard: "/slDashboard/",
  slTileCount: "/slDashboard/Tiles",
  slUser: "/slDashboard/user",
  slActions: "/actions/",
  slBatchActions: "/batch/",
  slActionsNeedsClarification: "NeedsClarification",
  slActionsPost: "SubmitForReview",
  slActionsAddPosters: "AddPosters",
  slActionsAddAttachment: "AddAttachment",
  slActionsDeleteAttachments: "DeleteAll",
  slActionsApproveEntries: "ApproveSLEntries",
  slActionsAuthorIsRecallingDraft: "RecallDraft",
  slActionsPosterIsRecallingSignedOffRequested: "RecallFromReview",
  slActionsDeleteDrafts: "Drafts",
  slActionsSendToPoster: "SendToPoster",
  slActionList: "ActionList",
  slEntrySendToPoster: "/slEntry/Entry/{slEntryId}/sendToPoster",
  slEntryPostedToSap: "/slEntry/Entry/{slEntryId}/postedToSap",
  slEntryFailedInSap: "/slEntry/Entry/{slEntryId}/failedInSap",
  slEntryValidateToSap: "/slEntry/Entry/{slEntryId}/validate",
  slEntrySubmitForReview: "/slEntry/Entry/{slEntryId}/SubmitSlForReview",
  slBatchSave: "save",
  slUpdateBatchAttachment: "updateAttachment",
  slBatchPost: "post",
  slBatchValidate: "validate",
  slBatchDetails: "/batch/{refguid}",
  slBatchEntryDetails: "/batch/slentry/details",
  slBatchEntryDetailsPerAction: "/batch/slentry/details/{actionName}",
  attachmentPath: "/attachment/",
  attachmentDownloadPath: "/Download/",
  CompanyCode: "/CompanyCodes",
  DocumentTypes: "/slEntry/DocumentTypes",
  search: "/slEntry/search",
  roles: "/slEntry/user/roles",
  FiscalMonths: "/FiscalMonths"
};
